<template>
  <div>
    <!-- 添加单个设备弹出层 -->
     <el-dialog
      :modal-append-to-body="false"
     :visible.sync="showCertificateView.show"
      :close-on-click-modal="false"
     class="dialogView"
      width="25%">
      <span slot="title" class="dialog-footer">
        <span>注册 CA 证书</span>
      </span>
      <div class="tips">
        <div class="tipContent">
          <div>
          注册码：
        </div>
         <el-tooltip content="659686d3ae9b49b18925430dfef12535494a66dfbdac45f3a961294fd92bb78d" placement="top" effect="light">
          <div class="ellipsis">659686d3ae9b49b18925430dfef12535494a66dfbdac45f3a961294fd92bb78d</div>
         </el-tooltip>
        </div>
        <div>如何生成验证证书，请查看<span class="link" @click="showDocs">文档</span></div>
      </div>
 <form method="post" id="form" enctype="multipart/form-data" action="http://172.26.82.82:9001/manager/certificate/regis">
      <el-row>
        <el-form :model="ruleForm" :rules="rules"  label-position="top">
          <el-form-item label="请输入CA证书名称" prop="name">
            <template slot="label">
              <div>
                 <span class="star">*</span>CA 证书名称
                  <el-tooltip :content="tips" placement="right" effect="light">
                    <span class="el-icon-question"></span>
                  </el-tooltip>
              </div>
            </template>
            <el-input v-model.trim="ruleForm.name" placeholder="请输入CA证书名称" name="registerName" size="small"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <span class="star">*</span>上传 CA 证书
        <el-tooltip :content="CATiPs" placement="right" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </el-row>
      <el-row>
        <el-button size="small" type="" @click="selectFile('rootCert')">点击上传</el-button>
      </el-row>
      <div v-if="fileName.rootShow" class="uploadFile">
        <div class="el-icon-document"></div>
        <div class="middle">{{fileName.rootCert}}</div>
        <div class="el-icon-circle-close delIcon" @click="removeFile('rootCert')"></div>
      </div>

      <!-- <el-row>
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          multiple
          :limit="3"
          :file-list="fileList">
          <el-button size="small" type="">点击上传</el-button>
        </el-upload>
      </el-row> -->
      <el-row>
        <span class="star">*</span>上传验证证书
        <el-tooltip :content="CATiPs" placement="right" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </el-row>
      <el-row>
        <el-button size="small" type=""  @click="selectFile('verifiCert')">点击上传</el-button>
      </el-row>
       <div v-if="fileName.verifiShow" class="uploadFile">
        <div class="el-icon-document"></div>
        <div class="middle">{{fileName.verifiCert}}</div>
        <div class="el-icon-circle-close delIcon" @click="removeFile('verifiCert')"></div>
      </div>
      <!-- <el-row>
        <el-row>
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          multiple
          :limit="3"
          :file-list="fileList">
          <el-button size="small" type="">点击上传</el-button>
        </el-upload>
      </el-row>
      </el-row> -->

      <!-- 用于放置用于上传的file控件节点 -->
      <div id="fileContent" style="display:none">
         rootCert<input  type="file" name="rootCert" id="rootCert" @change="showDelBtn('rootCert')"><br/>
          verifiCert<input  type="file" name="verifiCert" id="verifiCert" @change="showDelBtn('verifiCert')"><br/>
      </div>

      <div style="display:none">
         registerName<input type="text" value="NameTest0908-A" name="registerName"><br/>
        registerCode<input type="text" value="659686d3ae9b49b18925430dfef12535494a66dfbdac45f3a961294fd92bb78d" name="registerCode"><br/>
        version<input type="text" value="v1.0" name="version"><br/>
        id<input type="text" value="12345678" name="id"><br/>
        timestamp<input type="text" value="1597830676376" name="timestamp"><br/>
      </div>
  </form>
    <span slot="footer" class="dialog-footer">
        <el-button  type="primary" size="small" @click="registerCert">确 定</el-button>
        <el-button  size="small" @click="closeView">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog width="1100px" :modal-append-to-body=false title="文档" :visible.sync="dialogTableVisible">
      <div class="docs-container">
          <img :src="docsPng" alt="docs">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { regisCert } from '@/api/productControl'
import docsPng from '@/assets/imgs/docs.png'
export default {
  props: {
    showCertificateView: {
      type: Object
    }
  },
  methods: {
    showDocs () {
      this.dialogTableVisible = true
    },
    closeView () {
      this.$emit('close-view')
    },
    registerCert () {
      const rootFile = document.getElementById('rootCert')
      const verifiFile = document.getElementById('verifiCert')
      const formData = this.getFormData()
      console.log('formData:', formData)
      !this.ruleForm.name
        ? this.$message('请输入CA证书名称')
        : !(rootFile && rootFile.value)
          ? this.$message('上传 CA 证书')
          : !(verifiFile && verifiFile.value)
            ? this.$message('上传验证证书')
            : (
              regisCert(formData).then(res => {
                res = res.data
                console.log('注册证书返回的数据：', res)
                if (res.code === 200) {
                  this.$message({
                    message: '恭喜你，注册CA证书成功',
                    type: 'success'
                  })
                  // 关闭弹窗
                  this.$emit('close-view')
                } else {
                  this.$message.error(res.message)
                }
              })
            )
      // console.log("document.getElementById('form'):", document.getElementById('form'))
    },
    getFormData () {
      // 直接创建表示表单键值对的对象，灵活
      const formData = new FormData()
      formData.append('registerCode', '659686d3ae9b49b18925430dfef12535494a66dfbdac45f3a961294fd92bb78d')// registerCode暂时写死，后面每个账都有对应的registerCode
      formData.append('registerName', this.ruleForm.name)// this.ruleForm.name//'NameTest0908-A'
      formData.append('rootCert', document.getElementById('rootCert').files[0])
      formData.append('verifiCert', document.getElementById('verifiCert').files[0])
      return formData
    },
    removeFile (id) {
      // 把选择的文件去掉
      const fileNode = document.getElementById(id)
      fileNode.value = ''
      id === 'rootCert'
        ? (
          this.fileName.rootShow = false
        )
        : (
          this.fileName.verifiShow = false
        )
    },
    selectFile (id) {
      document.getElementById(id).click()
    },
    showDelBtn (id) {
      console.log('进入showDel')
      console.log('传入的id：', id)

      // 显示已经选择的按钮以及删除的文件
      id === 'rootCert'
        ? (
          this.fileName.rootCert = document.getElementById(id).files[0].name,
          this.fileName.rootShow = true
        )
        : (
          this.fileName.verifiCert = document.getElementById(id).files[0].name,
          this.fileName.verifiShow = true
        )
    }
  },
  data () {
    var validateName = (rule, value, callback) => {
      value === ''
        ? callback(new Error('请输入证书名称'))
        : ''
    }
    return {
      docsPng,
      dialogTableVisible: false,
      tips: 'CA 证书名称支持中文、英文字母、数字和下划线，长度限制 4-30',
      name: '',
      CATiPs: '仅支持 .cer、.crt、.pem 格式',
      fileList: [

      ],
      ruleForm: {
        name: ''
      },
      rules: {
        name: { validator: validateName, trigger: 'blur' }
      },
      fileName: {
        rootCert: '',
        verifiCert: '',
        rootShow: false,
        verifiShow: false
      }
    }
  },
  mounted () {
    console.log('====================================')
    console.log('showCertificateView:', this.showCertificateView)
    console.log('====================================')
  }
}
</script>
<style lang="less" scope>
.dialogView{
    .el-icon-question{
      margin-left: 5px;
      color: rgb(204, 204, 204);
    }
    .tips{
      padding: 15px;
      background: #fbfbfc;
      border: 1px solid #ecedee;
      font-size: 10px;
      white-space: nowrap;
      line-height: 25px;
      .tipContent{
         display: flex;
      }
      .link{
        color: #35a6df;
        cursor: pointer;
      }
    }
    .el-row{
      margin-top: 5px;
    }
    .star{
      color: red;
      margin-right: 5px;
    }
    .uploadFile{
      display: flex;
      align-items: center;
      margin-top: 10px;
      .middle{
        flex:auto
      }
    }
    .delIcon{
      cursor: pointer;
    }
  }
</style>
